import { History } from "lucide-react"
import { useTranslation } from "react-i18next"

type Props = {
  isExpanded: boolean
  onToggle: () => void
}

export function AmphoraOriginMarker({ isExpanded, onToggle }: Props) {
  const { t } = useTranslation()

  return (
    <div className="w-full flex items-center justify-center text-xs font-medium relative text-testing-2 my-2">
      <div className="border border-b absolute w-full border-testing-2/30" />
      <button
        type="button"
        aria-expanded={isExpanded}
        className="flex items-center gap-1.5 px-3 py-1 bg-background z-10 relative rounded-full border border-testing-2/40 cursor-pointer transition-colors hover:bg-[color-mix(in_srgb,var(--testing-2)_10%,var(--background))] hover:border-testing-2/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-testing-2/40"
        onClick={onToggle}
      >
        <History size={16} className="shrink-0" />
        <span className="text-xs">
          {isExpanded
            ? t("conversations.chat.amphoraOrigin.hide")
            : t("conversations.chat.amphoraOrigin.show")}
        </span>
      </button>
    </div>
  )
}
